"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRightsholderQuestionnaireFormSchema = exports.createRightsholderFormFields = exports.createRightsholderFormSchema = void 0;
const zod_1 = require("zod");
const error_messages_1 = require("@Entities/schemas/work/error-messages");
const address_schema_1 = require("@Entities/schemas/common/address-schema");
const error_messages_2 = require("@Const/error-messages");
const phone_number_schema_1 = require("@Entities/schemas/common/phone-number-schema");
const form_field_types_1 = require("@App/enum/form-field-types");
const populate_schema_1 = __importDefault(require("@App/forms/v2/helpers/populate-schema"));
const HFAPublisherNumberToolTip_1 = __importDefault(require("@Scenes/RightsholderRegistrationLayout/RightsholderRegistrationForm/IdentifiersSection/HFAPublisherNumberToolTip"));
const react_1 = __importDefault(require("react"));
const IpiNumberToolTip_1 = __importDefault(require("@Scenes/RightsholderRegistrationLayout/RightsholderRegistrationForm/IdentifiersSection/IpiNumberToolTip"));
const MemberTypeToolTip_1 = __importDefault(require("@Scenes/RightsholderRegistrationLayout/RightsholderRegistrationForm/MemberDetailsSection/MemberTypeToolTip"));
const MemberSubTypeToolTip_1 = __importDefault(require("@Scenes/RightsholderRegistrationLayout/RightsholderRegistrationForm/MemberDetailsSection/MemberSubTypeToolTip"));
const MemberNameToolTip_1 = __importDefault(require("@Scenes/RightsholderRegistrationLayout/RightsholderRegistrationForm/MemberDetailsSection/MemberNameToolTip"));
const common_fields_1 = require("@Entities/schemas/rightsholder/common-fields");
const validate_1 = require("@App/helpers/validate");
const createRightsholderFormSchema = zod_1.z.object({
    name: zod_1.z.string().min(1, error_messages_2.REQUIRED_MESSAGE).max(200, (0, error_messages_1.stringSizeMaxMessage)('Name', 200)),
    [address_schema_1.addressFormKey]: address_schema_1.addressSchema,
    [phone_number_schema_1.phoneNumberFormKey]: phone_number_schema_1.phoneNumberSchema,
    email: common_fields_1.email,
    memberType: zod_1.z.string().min(1, error_messages_2.REQUIRED_MESSAGE),
    memberSubType: zod_1.z.string().min(1, error_messages_2.REQUIRED_MESSAGE),
    ipiNumber: zod_1.z
        .string()
        .max(11, (0, error_messages_1.stringSizeMaxMessage)('IPI Number', 11))
        .refine((ipi) => (0, validate_1.IPIValidator)(ipi, false), 'Invalid IPI Number')
        .optional(),
    isni: zod_1.z
        .string()
        .refine((isni) => (0, validate_1.IsniValidator)(isni, false), 'Invalid ISNI')
        .optional(),
    hfaPublisherNumber: zod_1.z.string().max(6, (0, error_messages_1.stringSizeMaxMessage)('Publisher Account Number', 6)).optional(),
    termsAndConditions: zod_1.z
        .boolean({
        required_error: error_messages_2.REQUIRED_MESSAGE,
    })
        .refine((val) => val, {
        message: error_messages_2.REQUIRED_MESSAGE,
    }),
});
exports.createRightsholderFormSchema = createRightsholderFormSchema;
const createRightsholderQuestionnaireFormSchema = zod_1.z.object({
    question1: zod_1.z.string(),
    question2: zod_1.z.string(),
});
exports.createRightsholderQuestionnaireFormSchema = createRightsholderQuestionnaireFormSchema;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const createRightsholderQuestionnaireSchema = zod_1.z.object({
    questionAnswers: zod_1.z.array(zod_1.z.object({
        userId: zod_1.z.string(),
        questionId: zod_1.z.number(),
        answer: zod_1.z.string(),
    })),
});
const createRightsholderFormFieldsNoSchema = {
    name: {
        name: 'name',
        label: 'Member name',
        type: form_field_types_1.FormFieldTypes.TEXT,
        inputHeader: (react_1.default.createElement("h5", null,
            "Member Name",
            react_1.default.createElement(MemberNameToolTip_1.default, null))),
    },
    email: {
        name: 'email',
        label: 'Email',
        type: form_field_types_1.FormFieldTypes.TEXT,
    },
    memberType: {
        name: 'memberType',
        label: '',
        type: form_field_types_1.FormFieldTypes.DROPDOWN,
        placeholder: 'Select Member Type',
        className: 'register-dropdown',
        inputHeader: (react_1.default.createElement("h5", null,
            "Member Type",
            react_1.default.createElement(MemberTypeToolTip_1.default, null))),
        options: [
            {
                id: 'Songwriter',
                value: 'Songwriter',
                label: 'Self-Administered Songwriter',
            },
            {
                id: 'Publisher',
                value: 'Publisher',
                label: 'Publisher',
            },
            {
                id: 'CMO',
                value: 'CMO',
                label: 'CMO',
            },
            {
                id: 'Manager/Lawyer/Other',
                value: 'Manager/Lawyer/Other',
                label: 'Manager/Lawyer/Other',
            },
            {
                id: 'Administrator',
                value: 'Administrator',
                label: 'Administrator',
            },
        ],
    },
    memberSubType: {
        name: 'memberSubType',
        label: '',
        placeholder: "Select yes, no, or I don't know",
        type: form_field_types_1.FormFieldTypes.DROPDOWN,
        className: 'register-dropdown',
        inputHeader: (react_1.default.createElement("p", null,
            "Do you have a publisher, administrator, CMO, or digital distribution service collecting U.S. digital audio mechanical royalties on your behalf?",
            react_1.default.createElement(MemberSubTypeToolTip_1.default, null))),
        options: [
            {
                id: 'Yes',
                value: 'Fully Administered',
                label: 'Yes',
            },
            {
                id: 'No',
                value: 'Self Administered',
                label: 'No',
            },
            {
                id: "I don't know",
                value: "I don't know",
                label: "I don't know",
            },
        ],
    },
    ipiNumber: {
        name: 'ipiNumber',
        label: 'IPI Number',
        type: form_field_types_1.FormFieldTypes.TEXT,
        tooltip: react_1.default.createElement(IpiNumberToolTip_1.default, null),
    },
    isni: {
        name: 'isni',
        label: 'ISNI',
        type: form_field_types_1.FormFieldTypes.TEXT,
    },
    hfaPublisherNumber: {
        name: 'hfaPublisherNumber',
        label: 'Publisher Account Number',
        type: form_field_types_1.FormFieldTypes.TEXT,
        tooltip: react_1.default.createElement(HFAPublisherNumberToolTip_1.default, null),
    },
    termsAndConditions: {
        name: 'termsAndConditions',
        label: 'Accept ',
        type: form_field_types_1.FormFieldTypes.CHECKBOX,
        className: 'terms-and-conditions',
    },
    [address_schema_1.addressFormKey]: (0, address_schema_1.createAddressFormFields)(address_schema_1.addressFormKey, address_schema_1.addressSchema),
    [phone_number_schema_1.phoneNumberFormKey]: (0, phone_number_schema_1.createPhoneNumberFormFields)(phone_number_schema_1.phoneNumberFormKey),
    // [rightsholderContactFormKey]: rightsholderContactFormFields,
};
const createRightsholderFormFields = (0, populate_schema_1.default)(createRightsholderFormFieldsNoSchema, createRightsholderFormSchema);
exports.createRightsholderFormFields = createRightsholderFormFields;
